export default __webpack_public_path__ + "static/char-s-41-zh-Hant-1aa445bba2b6c62d35a0cfc2cee05f26.webp";